// import createHistory from 'history/createBrowserHistory'
const createHistory = require('history').createBrowserHistory
export default createHistory();